/**
 * Stores build information. The string literals are replaces at compile time by `set_version.js`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2023-10-30",
    versionChannel: "nightly",
    buildDate: "2023-10-30T00:20:56.782Z",
    commitHash: "5bebebddbe3c39362ba520cb0c9c28b3cb7f72a3",
};
